<template>
    <div>
        <div class="center" v-if="qrcode === ''">
            <v-text-field
                    type="number"
                    style="margin:0 auto;height:60px;margin-top:10px;"
                    label="Enter Amount"
                    solo
                    v-model="amount"
            />
            <div style="width:100%;float:left">
                <v-btn @click="submit" color="primary" style="margin:0 auto;width:100%">Submit</v-btn>
            </div>
        </div>
        <div class="center" v-else>
            <qr-code
                    :text="qrcode" :size="300" error-level="L">
            </qr-code>
            <div >
                <v-btn @click="qrcode = ''" color="primary" style="margin:0 auto;width:100%;margin-top: 10px;">Regenerate</v-btn>
            </div>
        </div>
        <Loader v-if="dialog"></Loader>
    </div>
</template>

<script>
  import Loader from "../components/Loader";

  export default {
    name: "VPN",
    data() {
      return {
        qrcode: "",
        amount: "",
        dialog: false,
      }
    },
    computed:{
      user(){
        return this.$store.getters.user
      }
    },
    methods: {
      notification(type,message){
        this.$notify({
          group: 'foo',
          title: 'Important message',
          text: message,
          duration:5000,
          type:type
        })
      },
      submit(){
        let vm = this;
        if(vm.user==null || !vm.user.phone) return vm.notification("error","Login Required!")
        if(vm.amount === "")return vm.notification("error","Amount Required");
        let doc ={
          'MobileNo':vm.user.phone,
          'Password':vm.user.password,
          'AuthKey':vm.user.authkey,
          'Source':'json',
          'Amount':vm.amount,
        };
        vm.dialog = true;
        vm.$store.dispatch("axiospost",{
          url:"Generate_UPI_QrCode",
          data:doc,
        }).then(function (res) {
          vm.dialog = false;
          vm.$store.dispatch("getbalance");
          if(res.data.Status==null) vm.notification("error","Try Agian!");
          if(res.data.Status==="False"){
            if(res.data.Message==="Not Authorised."){
              window.localStorage.removeItem("user");
              vm.$store.dispatch("getuser");
              vm.$router.push("/account");
              return vm.notification("error",res.data.Message);
            }
            return vm.notification("error",res.data.Message);
          }
          if(res.data.Status==="True"){
            vm.amount ="";
            vm.qrcode = res.data.Message;
            return vm.notification("success","Success");
          }
        }).catch(function (error) {
          console.log(error);
          vm.notification("error",error);
          vm.dialog = false;
        })
      },
    },
    components: {
      Loader
    }
  }
</script>
<style scoped>
    .center {
        width:300px;
        height: 300px;
        position: absolute;
        top:0;left:0;right:0;bottom:0;
        margin:auto;
    }
</style>
